import React, { Component, useReducer } from 'react';
import Grid from '../../Utils/Grid';
import PropTypes from 'prop-types';
import { standardActions } from '../../Utils/Grid/StandardActions';

class CentroCostoList extends Component{
    static propTypes = {
        data: PropTypes.object.isRequired,
        loader: PropTypes.bool.isRequired,
        onPageChange: PropTypes.func,
        onSortChange: PropTypes.func,
    };

    static defaultProps = {
        loading: false
    };

    componentDidMount = () => {
        const { listarCentroC, page } = this.props;
        listarCentroC(page);
    }

    render(){
        const { data, loader, listarCentroC: onPageChange, nivel} = this.props;
        localStorage.setItem('tituloForm', '');
        let ruta = window.location.href;
        let id_emp = ruta.split('/');
        return(
            <React.Fragment>
                <br />
                <h3 className="p-2 bg-secondary title">Centro Costo</h3>
                <div className="d-flex flex-row justify-content-start mb-2">
                    <a
                        href={`/#/contabilidad/${id_emp[5]}/centro_costo/crear`}
                        className='btn btn-primary'
                    >
                        Crear Centro costo
                    </a>
                    
                </div>
                {data &&
                    <Grid 
                        hover 
                        striped 
                        data={data} 
                        loading={loader} 
                        headerStyle={ { background: 'black' } } 
                        onPageChange={onPageChange}
                        //onSortChange={onSortChange} 
                    >
                        <TableHeaderColumn
                            isKey
                            dataField="codigo"
                            width="200"
                            dataSort
                            thStyle={ 
                                {color: 'white'}}
                            tdStyle={
                                {color: 'white'}}
                        >
                            Codigo
                        </TableHeaderColumn>
                        <TableHeaderColumn
                          
                            dataField="descripcion"
                            dataSort
                            thStyle={ 
                                {color: 'white'}}
                            tdStyle={
                                {color: 'white'}}
                        >
                            Descripción
                        </TableHeaderColumn>
                        
                        <TableHeaderColumn
                            thStyle={
                            {color: 'white'}}
                            dataField="id"
                            dataAlign="center"
                            dataSort
                            dataFormat={standardActions({ 
                                editar: "centro_costo", 
                                ver: "centro_costo",
                            })} 
                            
                        >
                            Acciones
                        </TableHeaderColumn>
                    </Grid>
                }
            </React.Fragment>
        );
    }
}

export default CentroCostoList;
